/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Happy_Canary_DazzleInputs */

const fr_zesty_happy_canary_dazzle = /** @type {(inputs: Zesty_Happy_Canary_DazzleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matin`)
};

/**

* @param {Zesty_Happy_Canary_DazzleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zesty_happy_canary_dazzle = /** @type {((inputs?: Zesty_Happy_Canary_DazzleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Happy_Canary_DazzleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zesty_happy_canary_dazzle(inputs)
});